export const FEDERAL = 'federal';
export const STATE = 'state';
export const LOCAL = 'local';

export const resultsList = {
  [LOCAL]: {
    header:
      'Oath donors drove real impact in places like Salt Lake County where we won the Treasurer position by only 1.5%',
    subheader:
      'Sheila Srivastava won her race by just XX votes. Oath donors supported heavily in September to help get Srivastava across the line with the resources she needed.',
    image: 'local-results.jpg',
  },
  [STATE]: {
    header: 'In 2024, Oath donors helped break the Republican supermajority in North Carolina.',
    subheader:
      'Dante Pittman won his race by just 871 votes. Oath donors accounted for nearly 25% of his total individual donors.',
    image: 'state-results.jpg',
  },
  [FEDERAL]: {
    header:
      'Strong support of Kristen McDonald Rivet immediately after her competitive primary allowed her to pull out a historic win from behind.',
    subheader:
      'Kristen McDonald Rivet overperformed by nearly 9 points. While she was trailing her Republican opponent in fundraising coming out of her primary election, Oath donors were quick to support through both a nominee fund (giving her hundreds of thousands of dollars the day after she won) and ongoing donations which allowed her to outspend her opponent by over $1M in the final month of the election. ',
    image: 'federal-results.jpg',
  },
};
